<template>
    <section>
        <div class="row progress" style="padding:0;margin:0;">
            <div class="indeterminate"></div>
        </div>
        <navigation></navigation>
        <!-- <h5 class="center-align">Login</h5> -->
        <!-- <section id="firebaseui-auth-container"></section> -->
        <img class="wave" :src="wav">
        <div class="container">
            <div class="img">
                <img :src="bg">
            </div>
            <div class="login-content">
                <form action="index.html" @submit.prevent>
                    <img :src="av">
                    <h2 class="title">Welcome</h2>
                    <div class="input-div one">
                    <!-- <font-awesome-icon :icon="['fas', 'fa-user']" /> -->
                            <div class="i">
                                <i class="small material-icons">account_circle</i>
                            </div>
                            <div class="div">
                                    <h5>Account Email</h5>
                                    <input type="text" class="input browser-dafault" v-model="accountEmail">
                            </div>
                    </div>
                    <div class="input-div store">
                    <!-- <font-awesome-icon :icon="['fas', 'fa-lock']" /> -->
                        <div class="i"> 
                                <!-- <i class="fas fa-lock"></i> -->
                                <i class="small material-icons">business</i>
                        </div>
                        <div class="div">
                                <h5>Company ID</h5>
                                <input type="text" class="input" v-model="storeID">
                        </div>
                    </div>
                    <div class="input-div pass">
                    <!-- <font-awesome-icon :icon="['fas', 'fa-lock']" /> -->
                        <div class="i"> 
                                <!-- <i class="fas fa-lock"></i> -->
                                <i class="small material-icons">lock</i>
                        </div>
                        <div class="div">
                                <h5>Company Password</h5>
                                <input type="password" class="input" v-model="storePassword">
                        </div>
                    </div>
                  
                    <input type="submit" class="btn" value="Login" @click="login">
                   <router-link to="/signup" tag="a">Not a Member yet?</router-link>

                </form>
            </div>
        </div>
    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";
import firebase from "firebase";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import backgroundPic from "@/assets/bg.svg";
import avatar from "@/assets/avatar.svg";
import wave from "@/assets/wave.png";

export default {
    name: "Login",
    data() {
        return {
            bg:backgroundPic,
            av:avatar,
            wav:wave,
            accountEmail:"",
            storeID:"",
            storePassword:""
        };
    },
    components: {
        navigation
    },
    mounted() {
        this.$$(".progress").hide();
        const inputs = document.querySelectorAll(".input");


        function addcl(){
            let parent = this.parentNode.parentNode;
            parent.classList.add("focus");
        }

        function remcl(){
            let parent = this.parentNode.parentNode;
            if(this.value == ""){
                parent.classList.remove("focus");
            }
        }


        inputs.forEach(input => {
            input.addEventListener("focus", addcl);
            input.addEventListener("blur", remcl);
        });

        let ui = firebaseui.auth.AuthUI.getInstance();
        if (!ui) {
            ui = new firebaseui.auth.AuthUI(firebase.auth());
        }
        var uiConfig = {
            credentialHelper: firebaseui.auth.CredentialHelper.NONE,
            signInFlow: "popup",
            signInOptions: [
                firebase.auth.EmailAuthProvider.PROVIDER_ID
            ]
            // signInOptions: [
            //     firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            //     firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            //     firebase.auth.EmailAuthProvider.PROVIDER_ID
            // ]
        };
        ui.start("#firebaseui-auth-container", uiConfig);
    },
    methods: {
        login(){

            const vm = this;
            this.$$(".progress").fadeIn();
            // console.log("log");
            // console.log(this.accountEmail+" "+this.storeID+" "+this.storePassword);
            var addMessage = firebase.app().functions('asia-east2').httpsCallable('loginMerchant');
            var jsonObj = {
                accountEmail:this.accountEmail,
                storeID:this.storeID,
                storePassword:this.storePassword
            }
            addMessage(jsonObj).then(function(result) {
            // Read result of the Cloud Function.
                var sanitizedMessage = result.data.text;
                // console.log(result);
                // console.log(result.data);
                
                if(result.data === "Account does not exists"){
                    vm.$$(".progress").fadeOut();
                    vm.$M.toast({ html: result.data });
                }
                else{
                    var token = result.data;
                    firebase.auth().signInWithCustomToken(token).catch(function(error) {
                        // Handle Errors here.
                        vm.$$(".progress").fadeOut();
                        var errorCode = error.code;
                        var errorMessage = error.message;
                        // console.log(error);
                        // console.log(error.message);
                        // ...
                        });
                }
               
                // ...
            }).catch(function(error) {
            // Getting the Error details.
                 vm.$$(".progress").fadeOut();
                var code = error.code;
                var message = error.message;
                var details = error.details;
                // console.log(error);
            // ...
            });
       }
    }
};
</script>

<style>
*{
	padding: 0;
	margin: 0;
	box-sizing: border-box;
}

body{
    font-family: 'Poppins', sans-serif;
    overflow: hidden;
}

.wave{
	position: fixed;
	bottom: 0;
	left: 0;
	height: 100%;
	z-index: -1;
}

.container{
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap :7rem;
    padding: 0 2rem;
}

.img{
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.login-content{
	display: flex;
	justify-content: flex-start;
	align-items: center;
	text-align: center;
}

.img img{
	width: 500px;
}

form{
	width: 360px;
}

.login-content img{
    height: 100px;
}

.login-content h2{
	margin: 15px 0;
	color: #333;
	text-transform: uppercase;
	font-size: 2.9rem;
}

.login-content .input-div{
	position: relative;
    display: grid;
    grid-template-columns: 7% 93%;
    margin: 25px 0;
    padding: 0px 0;
    border-bottom: 1px solid #ffffff;
}

.login-content .input-div.one{
	margin-top: 0;
}

.i{
	color: #d9d9d9;
	display: flex;
	justify-content: center;
	align-items: center;
}

.i i{
	transition: .3s;
}

.input-div > div{
    position: relative;
	height: 45px;
}

.input-div > div > h5{
	position: absolute;
	left: 10px;
	top: 15%;
	transform: translateY(-50%);
	color: #999;
	font-size: 18px;
	transition: .3s;
}

/* .input-div:before, .input-div:after{
	content: '';
	position: absolute;
	bottom: 0px;
	width: 0%;
	height: 2px;
	background-color: #38d39f;
	transition: .4s;
    left: 0px;
} */

.input-div:before{
	right: 50%;
}

.input-div:after{
	left: 50%;
}

.input-div.focus:before, .input-div.focus:after{
	width: 50%;
}

.input-div.focus > div > h5{
	top: -15px;
	font-size: 15px;
}

.input-div.focus > .i > i{
	color: #38d39f;
}

.input-div > div > input{
	position: absolute;
	left: 10px;
	top: 0;
	width: 100%;
	height: 100%;
	border: none;
	outline: none;
	background: none;
	padding: 0.5rem 0.7rem;
	font-size: 1.2rem;
	color: #555;
	font-family: 'poppins', sans-serif;
}

.input-div.pass{
	margin-bottom: 4px;
}

a{
	display: block;
	text-align: right;
	text-decoration: none;
	color: #999;
	font-size: 0.9rem;
	transition: .3s;
}

a:hover{
	color: #38d39f;
}

.btn{
	display: block;
	width: 100%;
	height: 50px;
	border-radius: 25px;
	outline: none;
	border: none;
	background-image: linear-gradient(to right, #32be8f, #38d39f, #32be8f);
	background-size: 200%;
	font-size: 1.2rem;
	color: #fff;
	font-family: 'Poppins', sans-serif;
	text-transform: uppercase;
	margin: 1rem 0;
	cursor: pointer;
	transition: .5s;
}
.btn:hover{
	background-position: right;
}


@media screen and (max-width: 1050px){
	.container{
		grid-gap: 5rem;
	}
}

@media screen and (max-width: 1000px){
	form{
		width: 290px;
	}

	.login-content h2{
        font-size: 2.4rem;
        margin: 8px 0;
	}

	.img img{
		width: 400px;
	}
}

@media screen and (max-width: 900px){
	.container{
		grid-template-columns: 1fr;
	}

	.img{
		display: none;
	}

	.wave{
		display: none;
	}

	.login-content{
		justify-content: center;
	}
}
</style>

<style lang="sass" scoped>
 @import url(https://fonts.googleapis.com/css?family=Poppins:600&display=swap)
 @import url(https://kit.fontawesome.com/a81368914c.js)


</style>
